import request from './request.js';
import {requestbody} from './request.js'

// 申报对比配置分页查询
export async function contrastSettingPageQuery(params = {}) {
    return await requestbody('/analysis/setting/page', 'post', params)
}

// 保存对比配置信息
export async function saveSetting(params = {}) {
    return await requestbody('/analysis/setting/save', 'post', params)
}

// 编辑对比配置信息
export async function updateSetting(params = {}) {
    return await requestbody('/analysis/setting/update', 'post', params)
}

// 删除对比配置信息
export async function deleteSetting(params = {}) {
    return await requestbody('/analysis/setting/delete', 'post', params)
}

// 查询对比配置下使用的企业
export async function querySetCompany(params = {}) {
    return await requestbody('/analysis/setting/querySettingCompany', 'post', params)
}



/**
 * 申报对比配置明细
 * */
// 根据对比配置获取明细项数据
export async function getAnalysusDetailPageListBySet(params = {}) {
    return await requestbody('/analysis/setting/detail/page', 'post', params)
}
// 保存对比项明细信息
export async function saveSetDetail(params = {}) {
    return await requestbody('/analysis/setting/detail/save', 'post', params)
}

// 编辑对比项明细信息
export async function updateSetDetail(params = {}) {
    return await requestbody('/analysis/setting/detail/update', 'post', params)
}

// 删除对比项明细信息
export async function deleteSetDetail(params = {}) {
    return await requestbody('/analysis/setting/detail/delete', 'post', params)
}


/**
 * 申报对比结果
 */
export async function contrastResultPageQuery(params = {}) {
    return await requestbody('/analysis/result/page', 'post', params)
}

export async function contrastResultDetailPageQuery(params = {}) {
    return await requestbody('/analysis/result/detail/page', 'post', params)
}